export default __webpack_public_path__ + "static/media/4700.4218b97b.png";